export default __webpack_public_path__ + "static/media/AC.0e3c2151.svg";